import { ORIGIN_URL_QUERY } from './queryString'
import { APPLICATION_KEY_STORAGE_NAME, USER_TOKEN_STORAGE_NAME, PERSONALIZATION_KEY_STORAGE_NAME } from './storage'
import { APP_KEY, INSTITUTION_API_URL, INSTITUTION_SLUG, LIVEKIT_SERVER_URL } from './system'
import {
  INSTITUTIONAL_MANAGEMENT_URL,
  ALERTS_OF_VULNERABILITY_URL,
  UNIFIED_LOGIN_URL,
  APP_CITIZEN_URL,
  CITIZEN_PROFILE_URL,
  SERVICES_LETTER_URL,
  SOCIALME_WEBSITE,
  DIGITAL_ARCHIVE_URL,
  REDIRECTOR_URL,
} from './urls'

import { CATEGORIES_OBJECT, CATEGORIES_OPTIONS, STATUS_OBJECT, STATUS_OPTIONS } from './variables'

export {
  ORIGIN_URL_QUERY,
  APPLICATION_KEY_STORAGE_NAME,
  USER_TOKEN_STORAGE_NAME,
  PERSONALIZATION_KEY_STORAGE_NAME,
  APP_KEY,
  INSTITUTION_API_URL,
  INSTITUTION_SLUG,
  INSTITUTIONAL_MANAGEMENT_URL,
  LIVEKIT_SERVER_URL,
  ALERTS_OF_VULNERABILITY_URL,
  UNIFIED_LOGIN_URL,
  APP_CITIZEN_URL,
  CITIZEN_PROFILE_URL,
  SERVICES_LETTER_URL,
  SOCIALME_WEBSITE,
  CATEGORIES_OBJECT,
  CATEGORIES_OPTIONS,
  STATUS_OBJECT,
  STATUS_OPTIONS,
  DIGITAL_ARCHIVE_URL,
  REDIRECTOR_URL,
}
